export const mapa = 'https://rpl-api.r.pl/rplmapi/maps/eb30da21-22d9-4b91-9dc2-6677fdf9f1b5/';
export const blog = '/api/blog';
const regulaminArchiwum = '/api/regulamin-archiwum';
const biura = '/api/biura';

const urls = {
  artykuly: '/api/artykuly/',
  kierunki: '/api/kierunki/',
  filtry: '/api/filtry/',
  bloczki: '/api/bloczki/',
  banery: '/api/banery/',
  wyszukiwarka: '/api/wyszukiwarka/',
  routing: '/api/routing',
  seo: '/api/seo',
  footer: 'https://static.r.pl/rpl-cdn/api/stopka.json',
  menu: 'https://rpl-api.r.pl/menu/api',
  newsletter: '/api/newsletter',
  mapa,
  schowek: '/api/schowek/',
  filmowySwiat: '/api/filmowy-swiat',
  blogMenu: `${blog}/menu`,
  blogSG: `${blog}/strona-glowna`,
  blogKategoria: `${blog}/kategoria/`,
  blogTag: `${blog}/tag/`,
  blogArtykuly: `${blog}/artykul/`,
  blogNaszeKierunki: `${blog}/nasze-kierunki`,
  blogNaszeKierunkiArticles: `${blog}/kraj`,
  filmowySwiatRainbow: '/api/filmowy-swiat',
  regulaminArchiwumPromocjiPobierz: `${regulaminArchiwum}/pobierz`,
  biuraWyszukaj: `${biura}/wyszukaj`,
  biuraPobierz: `${biura}/pobierz-biura`,
  biuraPobierzSzczegolyBiura: `${biura}/pobierz-szczegoly-biura`,
  podstronaUA: '/api/podstrona-ukraina',
  katalogi: 'https://images2.r.pl/r-pl/nuxt/lps/katalogi/katalogi_v2.json',
  pdfViewer: '/viewer-pdf/pobierz',
  praca: '/api/praca',
};

export default urls;
